import { render, staticRenderFns } from "./binvitation.vue?vue&type=template&id=57de774c&scoped=true&"
import script from "./binvitation.vue?vue&type=script&lang=js&"
export * from "./binvitation.vue?vue&type=script&lang=js&"
import style0 from "./binvitation.vue?vue&type=style&index=0&id=57de774c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57de774c",
  null
  
)

export default component.exports